import { render } from "./Accordion.vue?vue&type=template&id=75af96cf"
import script from "./Accordion.vue?vue&type=script&lang=js"
export * from "./Accordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Advanced/Accordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75af96cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75af96cf', __exports__)) {
    api.reload('75af96cf', __exports__)
  }
  
  module.hot.accept("./Accordion.vue?vue&type=template&id=75af96cf", () => {
    api.rerender('75af96cf', render)
  })

}


export default __exports__